import { render, staticRenderFns } from "./BaseActorLogos.vue?vue&type=template&id=9831d428&scoped=true&"
import script from "./BaseActorLogos.vue?vue&type=script&lang=js&"
export * from "./BaseActorLogos.vue?vue&type=script&lang=js&"
import style0 from "./BaseActorLogos.vue?vue&type=style&index=0&id=9831d428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9831d428",
  null
  
)

export default component.exports